<template>
  <span class="screen-hotkey" :class="{ active }">
    <span>{{ hotkey }}</span>
  </span>
</template>
<script setup lang="ts">
defineProps({
  hotkey: {
    type: String,
    required: true
  },
  active: {
    type: Boolean,
    default: false
  }
})
</script>
<style lang="scss" scoped>
.screen-hotkey {
  display: none;
}
@media screen and (min-width: $grid-breakpoint-md) {
  .screen-hotkey {
    font-size: 12px;
    align-items: center;
    background-color: var(--color-bg-unselected);
    border: none;
    border-radius: $border-radius-sm;
    color: var(--color-text-primary);
    display: flex;
    font-family: $font-family-pilat-bold;
    height: $spacer-4;
    line-height: $spacer-4;
    justify-content: center;
    text-transform: uppercase;
    width: $spacer-4;
    &.active {
      background-color: var(--color-accent-primary);

      span {
        color: var(--color-text-dark-inverse) !important;
      }
    }
  }
}
</style>
